import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowUpRight, Linkedin } from "lucide-react";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0a0a0a] border-t border-[#1e1e1e] relative overflow-hidden">
      <div className="absolute inset-0 gp-blueprint opacity-50" />
      <div className="relative mx-auto max-w-[1200px] px-6 lg:px-8 py-20 lg:py-24">
        <div className="border-b border-[#1e1e1e] pb-16">
          <p className="eyebrow">Let's build better systems</p>
          <h2 className="mt-5 text-4xl sm:text-5xl lg:text-[56px] font-semibold tracking-[-0.03em] leading-[1.05] text-white max-w-3xl">
            Ready to operate faster, smarter, and more profitably?
          </h2>
          <button
            data-testid="footer-cta-btn"
            onClick={() => goTo("contact")}
            className="mt-9 inline-flex items-center gap-2 rounded-lg bg-white px-5 py-3 text-sm font-medium text-[#0a0a0a] hover:bg-[#15b351] hover:text-white transition-colors"
          >
            Book a Free Consultation <ArrowUpRight className="h-4 w-4" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pt-14">
          <div className="md:col-span-1">
            <img src="/brand/graphikpro-logo-dark.png" alt="Graphikpro" className="h-7 w-auto" />
            <p className="mt-5 text-sm text-[#7c7c7c] leading-relaxed max-w-xs">
              Business systems, AI solutions, and workflow automation that drive measurable results.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.085em] text-[#7c7c7c]">Company</p>
            <ul className="mt-5 space-y-3 text-sm text-[#a7a7a7]">
              <li><button data-testid="footer-link-services" onClick={() => goTo("services")} className="hover:text-white transition-colors">What We Do</button></li>
              <li><button data-testid="footer-link-solutions" onClick={() => goTo("solutions")} className="hover:text-white transition-colors">Solutions</button></li>
              <li><button data-testid="footer-link-industries" onClick={() => goTo("industries")} className="hover:text-white transition-colors">Industries</button></li>
              <li><button data-testid="footer-link-about" onClick={() => goTo("about")} className="hover:text-white transition-colors">About</button></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.085em] text-[#7c7c7c]">Projects</p>
            <ul className="mt-5 space-y-3 text-sm text-[#a7a7a7]">
              <li><Link data-testid="footer-link-paytrackr" to="/projects/paytrackr" className="hover:text-white transition-colors">PayTrackr</Link></li>
              <li><button data-testid="footer-link-projects" onClick={() => goTo("projects")} className="hover:text-white transition-colors">All Projects</button></li>
              <li><button onClick={() => goTo("engagement")} className="hover:text-white transition-colors">Engagement Model</button></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.085em] text-[#7c7c7c]">Contact</p>
            <ul className="mt-5 space-y-3 text-sm text-[#a7a7a7]">
              <li><a href="mailto:askus@graphikpro.com" className="hover:text-white transition-colors">askus@graphikpro.com</a></li>
              <li><a href="tel:+919342055964" className="hover:text-white transition-colors">+91 93420 55964</a></li>
              <li><a href="https://www.linkedin.com/in/madhiee/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-white transition-colors"><Linkedin className="h-4 w-4" /> LinkedIn</a></li>
            </ul>
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.085em] text-[#7c7c7c]">Registered Office</p>
            <address className="mt-3 not-italic text-sm text-[#a7a7a7] leading-relaxed">
              Graphikpro Private Limited<br />
              30, Subrayan Street, Tagore Nagar,<br />
              Lawspet, Puducherry - 605008
            </address>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#1e1e1e] flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#7c7c7c]">
          <p>© {new Date().getFullYear()} Graphikpro. All rights reserved.</p>
          <p className="font-mono">Technology should serve business outcomes.</p>
        </div>
      </div>
    </footer>
  );
};
